import React from "react";
import LegalDoc from "../components/LegalDoc";

export default function Privacy() {
  return <LegalDoc docKey="privacy" />;
}
